import FallbackClassImg from "assets/fallback.png";
import styled from "styled-components";
import { WebIcon } from "ui/icons";
import { GraduationIcon } from "ui/icons/GraduationIcon";
import { StarFullIcon } from "ui/icons/StarFullIcon";
import { UsersIcon } from "ui/icons/UsersIcon";
import { defaultThemeColors, fonts, mediaSizes } from "ui/theme";
import { getAvatarUrl } from "utils";

export const HeaderPaymentDetailsCard = ({
    profilePic,
    title,
    rate,
    review,
    classType,
    onlineType,
    levelOfStudent,
}) => (
    <HeaderWrapper>
        <ImageContainer>
            {profilePic ? (
                <img src={getAvatarUrl(profilePic)} alt='profile Picture' />
            ) : (
                <img src={FallbackClassImg} alt='profile Picture' />
            )}
        </ImageContainer>
        <HeaderContent>
            <Heading>{title}</Heading>
            <IconTextWrapper>
                <RatingText>
                    <p className='rating'>
                        <StarFullIcon />
                        {rate || 0}
                    </p>
                    <p className='review'>({review || 0} reviews)</p>
                </RatingText>
            </IconTextWrapper>
            <IconTextWrapper>
                <UsersIcon /> <p>{classType === "Online class" ? "Private class" : classType}</p>
            </IconTextWrapper>
            <IconTextWrapper>
                <WebIcon /> <p>{onlineType}</p>
            </IconTextWrapper>
            <IconTextWrapper>
                <GraduationIcon /> <p>Teaching {levelOfStudent}</p>
            </IconTextWrapper>
        </HeaderContent>
    </HeaderWrapper>
);

const Heading = styled.p`
    font-family: Montserrat;
    color: ${defaultThemeColors.txt};
    font-size: ${fonts.sizes.regular};
    font-weight: 600;
    @media (width >= ${mediaSizes.md}) {
        font-size: ${fonts.sizes.medium};
    }
    @media (width >= ${mediaSizes.lg}) {
        font-size: ${fonts.sizes.big};
    }
`;

const HeaderWrapper = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
`;

const HeaderContent = styled.div`
    display: grid;
    gap: 0.5rem;
    height: fit-content;
`;

const ImageContainer = styled.div`
    width: 160px;
    border-radius: 12px;
    overflow: hidden;
    aspect-ratio: 1/1;

    & > img {
        width: 100%;
        height: 100%;
        aspect-ratio: 1/1;
        object-fit: cover;
        border-radius: 12px;
        filter: contrast(0.9);
    }
`;


const IconTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: ${defaultThemeColors.txt};

    & > p {
        font-size: ${fonts.sizes.extraSmall};
        font-weight: 500;
    }

    & > svg {
        width: 0.8rem;
        height: 0.8rem;
    }


    @media (width >= ${mediaSizes.lg}) {
        & > p {
            font-size: 16px;
            font-weight: 500;
        }

        & > svg {
            width: 1.2rem;
            height: 1.2rem;
        }
    }
`;

const RatingText = styled.div`
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: ${fonts.sizes.extraSmall};
    @media (width >= ${mediaSizes.md}) {
        font-size: ${fonts.sizes.small};
    }
    @media (width >= ${mediaSizes.lg}) {
        font-size: ${fonts.sizes.regular};
    }

    & > .rating {
        display: flex;
        align-items: center;
        gap: 0.2rem;
        color: ${defaultThemeColors.pink};

        & > svg {
            width: 0.85rem;
            height: 0.85rem;
        }
    }

    & > .review {
        color: ${defaultThemeColors.txt};
        opacity: 0.6;
    }
`